module.exports = __webpack_public_path__ + "assets/media/announcer_prepare2.71f34a91.mp3";